import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { getImages } from '../media/index.js';

function useActualImages(options) {
  const {
    imageParams,
    resolutionsByBreakpoint,
    hasWebpSupport,
    images,
    additionalParameters
  } = options;
  const useMemoHandler = useMemo(() => {
    if (resolutionsByBreakpoint) {
      return;
    }

    if (!isEmpty(images)) {
      return images;
    }

    if (!imageParams) return;
    return getImages({
      imageParams,
      additionalParameters,
      hasWebpSupport
    });
  }, [additionalParameters, hasWebpSupport, imageParams, images, resolutionsByBreakpoint]);
  return useMemoHandler;
}

export { useActualImages };
